import Store from 'store/store'
import { Component } from 'utils/jsx'
import Convert from 'utils/convert'

import InputFile from 'components/dom/InputFile'
import FileDropper from 'components/dom/FileDropper'
import Button from 'components/dom/Button'

export default class Cover extends Component {
  beforeRender () {
    this.update = this.update.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleDelete = this.handleDelete.bind(this)

    this.state = {
      label: ['Ajouter une image de couverture', ' Remplacer l’image de couverture'],
      icon: ['plus', 'exchange-alt']
    }
  }

  template () {
    return (
      <div class='cover' store-class-has-image={Store.cover}>
        <div class='cover__image'>
          <img ref={this.ref('image')} />
          <div class='cover__image-footer'>
            <Button class='button--delete' icon='trash-o' event-click={this.handleDelete} title='Supprimer' />
            <div class='cover__image-infos' ref={this.ref('infos')} />
          </div>
        </div>
        <InputFile accept='image/*' event-change={this.handleInput} ref={this.ref('input')}>
          {this.state.label[0]}
        </InputFile>
        <FileDropper event-change={this.handleInput} />
      </div>
    )
  }

  afterRender () {
    Store.cover.subscribe(this.update)
    this.update()
  }

  update () {
    const hasCover = !!Store.cover.current
    this.refs.input.refs.button.refs.label.textContent = this.state.label[+hasCover]
    this.refs.input.refs.button.refs.icon.className = `fa fa-${this.state.icon[+hasCover]}`

    if (!hasCover) return
    this.refs.infos.textContent = Store.cover.current.name
    this.refs.image.src = Store.cover.current.src
  }

  async handleInput (files = []) {
    const file = files && files.length && files[0]
    if (!file) return

    const src = URL.createObjectURL(file)
    const image = await Convert.objectURL(src).toImage()

    Store.cover.set({
      src,
      name: file.name,
      width: image.width,
      height: image.height,
      size: file.size,
      type: file.type
    })
  }

  handleDelete () {
    Store.cover.set(undefined)
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Cover.js